import { render, staticRenderFns } from "./ProducaoBar.vue?vue&type=template&id=e355137e&scoped=true"
import script from "./ProducaoBar.vue?vue&type=script&lang=js"
export * from "./ProducaoBar.vue?vue&type=script&lang=js"
import style0 from "./ProducaoBar.vue?vue&type=style&index=0&id=e355137e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e355137e",
  null
  
)

export default component.exports